// extracted by mini-css-extract-plugin
module.exports = {"menu1":"RightClick_menu1__2N25s","avasagButton2":"RightClick_avasagButton2__3EiR3"};